<div class="modal-header">
  <span class="modal-title" id="modal-title"><b>Pig Product Specifications</b></span>
  <button type="button" class="close" aria-describedby="modal-title" (click)="modal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="d-flex flex-column w-100" *ngIf="!!item">
    <a *ngIf="!isLoadingDwg else loader" class="hover" [routerLink]="" (click)="getCutSheet.emit(item.productId || -1)">View Cut Sheet</a>
    <img class="align-self-center my-3" style="width: 250px; padding: 10px" [src]="item.drawing | imgFromBytes"
         alt="Product Picture">

    <div class="d-flex">
      <div class="d-flex flex-column mx-auto">
        <small>Part Name:</small>
        <small>Product Part #:</small>
      </div>
      <div class="d-flex flex-column mb-3 mx-auto">
        <small>{{item.productName}}</small>
        <small>{{item.partNumber}}</small>
      </div>
    </div>
    <span class="my-3"></span>
    <ng-template #loader>
      <app-loader></app-loader>
    </ng-template>
    <ngb-accordion #pigReferencesAccordion *ngIf="!isLoadingDetail else loader">
      <ngb-panel *ngIf="(productInfo || []).length > 0" id="specialConsiderations"
                 title="Special Product Considerations">
        <ng-template ngbPanelContent>
          <table class="table table-striped table-sm">
            <thead>
              <tr>
                <th></th>
                <th>English</th>
                <th>Metric</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let info of productInfo">
                <td><span [innerHTML]="info.name"></span></td>
                <td>{{info.englishValue}}&nbsp;{{info.englishUOM}}</td>
                <td>{{info.metricValue}}&nbsp;{{info.metricUOM}}</td>
              </tr>
            </tbody>
          </table>
        </ng-template>
      </ngb-panel>

      <ngb-panel *ngIf="(bypassInfo || []).length > 0" id="bypassInfo" title="Bypass Information">
        <ng-template ngbPanelContent>
          <div class="d-flex flex-column w-100">
            <img class="mx-auto" width="250px" src="https://assets.tdwilliamson.com/img/BypassHoles.png"
                 alt="BypassHoles">
            <span class="mb-2 mx-auto">Bypass Hold Recommendation based on 3%</span>
            <div class="d-flex w-100 mx-auto" *ngFor="let bypass of bypassInfo">
              <small class="me-2 mx-auto">{{bypass.numberHoles}}&nbsp;Bypass Holes</small>
              <small class="mx-auto">{{bypass.holeDiameter}}</small>
            </div>
          </div>
        </ng-template>
      </ngb-panel>

      <ngb-panel *ngIf="(replacementParts || []).length > 0" id="replacementParts" title="Replacement Parts">
        <ng-template ngbPanelContent>
          <table class="table table-striped table-sm">
            <thead>
              <tr>
                <th>Item #</th>
                <th>Name</th>
                <th>Qty</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let part of replacementParts">
                <td><small>{{part.itemID}}</small></td>
                <td><small>{{part.itemName}}</small></td>
                <td class="text-end"><small>{{part.quantity}}</small></td>
              </tr>
            </tbody>
          </table>
        </ng-template>
      </ngb-panel>

      <ngb-panel *ngIf="(pigComponents || []).length > 0" id="components" title="Components">
        <ng-template ngbPanelContent>
          <table class="table table-striped table-sm">
            <thead>
              <tr>
                <th>Item #</th>
                <th>Name</th>
                <th>Qty</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let part of pigComponents">
                <td><small>{{part.itemNumber}}</small></td>
                <td><small>{{part.description}}</small></td>
                <td class="text-end"><small>{{part.quantity}}</small></td>
              </tr>
            </tbody>
          </table>
        </ng-template>
      </ngb-panel>

      <ngb-panel *ngIf="(pigAccessories || []).length > 0" id="accessory" title="Accessories">
        <ng-template ngbPanelContent>
          <table class="table table-striped table-sm">
            <thead>
              <tr>
                <th>Required</th>
                <th>Part #</th>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let part of pigAccessories">
                <td><small>{{part.required ? 'YES' : 'NO'}}</small></td>
                <td><small>{{part.partNumber}}</small></td>
                <td><small>{{part.description}}</small></td>
              </tr>
            </tbody>
          </table>
        </ng-template>
      </ngb-panel>

      <ngb-panel *ngIf="(associatedProducts || []).length > 0" id="associatedProducts" title="Associated Products">
        <ng-template ngbPanelContent>
          <table class="table table-striped table-sm">
            <thead>
              <tr>
                <th>Name
                <th>
                <th>Description</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let part of associatedProducts">
                <td><small>{{part.text}}</small></td>
                <td><small>{{part.description}}</small></td>
                <td><small *ngIf="!!part.hasDrawing">
                    <a [routerLink]="">View Drawing</a>
                  </small></td>
              </tr>
            </tbody>
          </table>
        </ng-template>
      </ngb-panel>
    </ngb-accordion>


    <!-- <b class="border-bottom mb-2 w-100">Bypass Information</b>
    <img class="mx-auto" width="250px" src="https://assets.tdwilliamson.com/img/BypassHoles.png" alt="BypassHoles">
    <span class="mb-2 mx-auto">Bypass Hold Recommendation based on 3%</span>
    <div class="d-flex w-100 mx-auto" *ngFor="let bypass of bypassInfo">
      <small class="me-2 mx-auto">{{bypass.numberHoles}}&nbsp;Bypass Holes</small>
      <small class="mx-auto">{{bypass.holeDiameter}}</small>
    </div> -->

  </div>
</div>
<div class=" modal-footer">
  <button type="button" class="btn btn-secondary" (click)="modal.dismiss(false)">Close</button>
</div>
